import http from './api'

const route = 'rest/tipoficha/'

export default {

    listar: () => {
        return http.post(route + 'listar', {
        })
    },
    salvar: (animal) => {
        return http.post(route + 'salvar', animal)
    },
    listarAtivo: () => {
        return http.post(route + 'listarativa', {
        })
    },
}
